<template>
  <div>
    <headerSection></headerSection>
    <div class="x-main-content x-cashback-page"
         :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
      <div class="container">

        <!-- Page Header -->
        <div class="x-page-header">
          <div class="x-page-title-component">
            <div class="-inner-wrapper">
              <div class="-icon-wrapper">
                <i class="fas fa-coins"></i>
              </div>
              <h1 class="-title">คืนยอดเล่น</h1>
            </div>
          </div>
          <p class="-description">รับเงินคืนจากยอดเล่นทุกวัน</p>
        </div>

        <!-- Banner Image -->
        <div class="x-banner-section">
          <img src="https://firebasestorage.googleapis.com/v0/b/deltaplus-th.appspot.com/o/images%2F-Mz_m97zG-sNYbk4wxDC.png?alt=media&token=e1c3780f-c25e-4ff7-98dc-50c0f740e9fd" class="-banner-img" alt="คืนยอดเล่น">
        </div>

        <!-- Main Content Card -->
        <div class="x-cashback-card">
          <div class="-card-header">
            <i class="fas fa-chart-pie"></i>
            <span>ยอดเล่นวันนี้</span>
          </div>

          <!-- Stats Grid -->
          <div class="x-stats-grid">
            <div class="x-stat-card -deposit">
              <div class="-icon-circle">
                <i class="fas fa-arrow-down"></i>
              </div>
              <div class="-stat-content">
                <span class="-label">ฝาก</span>
                <span class="-value">{{ numberWithCommas(this.cashback.deposit) }}</span>
              </div>
            </div>

            <div class="x-stat-card -withdraw">
              <div class="-icon-circle">
                <i class="fas fa-arrow-up"></i>
              </div>
              <div class="-stat-content">
                <span class="-label">ถอน</span>
                <span class="-value">{{ numberWithCommas(this.cashback.withdraw) }}</span>
              </div>
            </div>
          </div>

          <!-- Total Card -->
          <div class="x-total-card">
            <div class="-total-icon">
              <i class="fas fa-wallet"></i>
            </div>
            <div class="-total-content">
              <span class="-label">รายได้ทั้งหมด</span>
              <span class="-value">{{ numberWithCommas(this.cashback.total) }}</span>
            </div>
          </div>

          <!-- Transfer Button -->
          <div class="x-action-section">
            <button
              class="x-transfer-btn"
              :class="{ '-disabled': !cashback.total }"
              @click="moveCashbackToWallet()"
            >
              <i class="fas fa-exchange-alt"></i>
              <span>โอนเงินเข้ากระเป๋าหลัก</span>
            </button>
          </div>
        </div>

        <!-- Rules Section -->
        <div class="x-rules-card" v-if="detail">
          <div class="-rules-header">
            <i class="fas fa-star"></i>
            <span>รายละเอียดโปรโมชั่น</span>
          </div>
          <div class="-rules-content" v-html="nl2br(detail)"></div>
        </div>

      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      cashback: [],
       detail:''
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key) {
        this.$store.commit('user/SET_LOADING', true)
        axios.get(`https://api.deltaplus-dp.com/qcashback/cashback/${this.cashback.key}`)
        setTimeout(() => {
          this.getCashBack()
          this.$store.commit('user/SET_LOADING', false)
        }, 2000)
      }
    },
    checkStyle () {
      if (this.cashback && this.cashback.total > 0) {
        return 'background: linear-gradient(180deg,#f9a25b , #f37320 );height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
     nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref(`/cashback/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>
<style scoped>
.x-cashback-page {
  min-height: 100vh;
  padding: 25px 0 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Page Header */
.x-page-header {
  text-align: center;
  padding: 20px 0;
}

.x-page-title-component .-inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.x-page-title-component .-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ffe867 10%, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.x-page-title-component .-icon-wrapper i {
  font-size: 22px;
  color: #1b1b41;
}

.x-page-title-component .-title {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.-description {
  color: #a0a0a0;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin-top: 10px;
}

/* Banner Section */
.x-banner-section {
  text-align: center;
  margin-bottom: 20px;
}

.x-banner-section .-banner-img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

/* Main Content Card */
.x-cashback-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid #fec33f;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.15);
}

.-card-header {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.-card-header i {
  color: #ffc107;
  font-size: 18px;
}

.-card-header span {
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

/* Stats Grid */
.x-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  padding: 20px;
}

.x-stat-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.x-stat-card:hover {
  background: rgba(255, 255, 255, 0.08);
}

.x-stat-card.-deposit .-icon-circle {
  background: linear-gradient(180deg, #4ade80, #22c55e);
}

.x-stat-card.-withdraw .-icon-circle {
  background: linear-gradient(180deg, #f87171, #ef4444);
}

.-icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.-icon-circle i {
  color: #fff;
  font-size: 20px;
}

.-stat-content {
  text-align: center;
}

.-stat-content .-label {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  color: #a0a0a0;
  margin-bottom: 5px;
}

.-stat-content .-value {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.x-stat-card.-deposit .-stat-content .-value {
  color: #4ade80;
}

.x-stat-card.-withdraw .-stat-content .-value {
  color: #f87171;
}

/* Total Card */
.x-total-card {
  background: linear-gradient(135deg, rgba(254, 195, 63, 0.15), rgba(254, 138, 2, 0.15));
  border: 1px solid #fec33f;
  border-radius: 15px;
  padding: 20px;
  margin: 0 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.-total-icon {
  width: 55px;
  height: 55px;
  background: linear-gradient(180deg, #fec33f, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 25px rgba(254, 195, 63, 0.5);
  animation: pulse-gold 2s ease-in-out infinite;
}

@keyframes pulse-gold {
  0%, 100% {
    box-shadow: 0 0 15px rgba(254, 195, 63, 0.4);
  }
  50% {
    box-shadow: 0 0 30px rgba(254, 195, 63, 0.7), 0 0 40px rgba(254, 195, 63, 0.3);
  }
}

.-total-icon i {
  color: #1b1b41;
  font-size: 24px;
}

.-total-content {
  text-align: center;
}

.-total-content .-label {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  color: #a0a0a0;
}

.-total-content .-value {
  display: block;
  font-family: 'Kanit', sans-serif;
  font-size: 30px;
  font-weight: 700;
  color: #ffc107;
  text-shadow: 0 0 15px rgba(255, 193, 7, 0.4);
}

/* Action Section */
.x-action-section {
  text-align: center;
  padding: 0 20px 25px;
}

.x-transfer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 35px;
  background: linear-gradient(180deg, #f9a25b, #f37320);
  border: none;
  border-radius: 30px;
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(243, 115, 32, 0.4);
}

.x-transfer-btn:hover:not(.-disabled) {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(243, 115, 32, 0.5);
}

.x-transfer-btn.-disabled {
  background: linear-gradient(180deg, #666, #555);
  cursor: not-allowed;
  box-shadow: none;
}

.x-transfer-btn i {
  font-size: 18px;
}

/* Rules Card */
.x-rules-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  overflow: hidden;
}

.-rules-header {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.-rules-header i {
  color: #ffc107;
  font-size: 16px;
}

.-rules-header span {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.-rules-content {
  padding: 25px;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  color: #d0d0d0;
  line-height: 1.7;
  text-align: center;
}

/* Responsive */
@media (max-width: 576px) {
  .x-stats-grid {
    grid-template-columns: 1fr;
    padding: 15px;
  }

  .x-stat-card {
    flex-direction: row;
    padding: 15px;
    gap: 15px;
  }

  .-icon-circle {
    width: 45px;
    height: 45px;
  }

  .-stat-content {
    text-align: left;
  }

  .-stat-content .-value {
    font-size: 20px;
  }

  .x-total-card {
    margin: 0 15px 15px;
    padding: 15px;
  }

  .-total-icon {
    width: 50px;
    height: 50px;
  }

  .-total-content .-value {
    font-size: 24px;
  }

  .x-action-section {
    padding: 0 15px 20px;
  }

  .x-transfer-btn {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }

  .x-page-title-component .-title {
    font-size: 20px;
  }
}
</style>
